var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPointCoins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2785_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.163 153.49H61.397V165H106.163V153.49Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.163 136.222H61.397V147.732H106.163V136.222Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.88 103.498C119.024 96.1789 123.431 86.1769 123.431 75.1461C123.431 51.7634 103.673 32.9988 79.9395 34.6356C60.0701 36.0035 43.9126 51.9914 42.3401 71.8492C41.2996 85.0487 46.5724 97.0499 55.4637 105.152C59.3335 108.677 61.397 113.774 61.397 119.012V130.47H106.163V118.959V117.141C106.163 112.015 108.297 107.175 111.88 103.509V103.498ZM72.8838 118.954C72.6266 110.22 68.7392 102.077 62.4726 95.9392C62.1044 95.5767 61.7478 95.2085 61.397 94.8285C55.9021 88.8484 52.874 80.5709 53.9321 71.592C55.5046 58.3223 66.2314 47.689 79.5128 46.2217C97.0673 44.2868 111.921 57.9774 111.921 75.1403C111.921 81.6524 109.782 87.6676 106.163 92.5136C105.444 93.4781 104.667 94.3959 103.831 95.2669C97.9676 101.382 94.6472 109.489 94.6472 117.96V118.948H72.8779L72.8838 118.954Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5737 26.8609V0L77.0636 0V26.8609H88.5737Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.139 86.9778H165V75.4677H138.139V86.9778Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8609 75.4618H0V86.9719H26.8609V75.4618Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.914 45.9449L144.907 26.9514L136.768 18.8125L117.775 37.806L125.914 45.9449Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0863 116.489L20.0928 135.483L28.2317 143.622L47.2252 124.628L39.0863 116.489Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2249 37.8117L28.2314 18.8182L20.0926 26.9571L39.0861 45.9506L47.2249 37.8117Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.769 124.633L136.763 143.627L144.902 135.488L125.908 116.494L117.769 124.633Z",
    fill: "#F6A000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2785_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 165,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointCoins);
export default __webpack_public_path__ + "static/media/pointCoins.789ddfd723ed2b0ed672917e2a9f3d49.svg";
export { ForwardRef as ReactComponent };